import styled from 'styled-components';

const ButtonAnimation = styled.button<{ opened: boolean }>`
  transform: ${({ opened }) => (opened ? 'rotate(0)' : 'rotate(180deg)')};
  transition-duration: 400ms;
  padding-top: ${({ theme }) => theme.spacing[4]};
`;

export default ButtonAnimation;
